import type {Auth} from 'src/typings';
import type {SutorHomePageData} from './types';
import type {HomepageDataService} from './homepage.data-service';
import type LoginService from 'shared/login/login.service';

export class HomepageService {
    public static serviceName = 'homepageService';

    /*@ngInject*/
    constructor(private homepageDataService: HomepageDataService,
                private loginService: LoginService) {
    }

    public async getHomePageData(): Promise<SutorHomePageData> {
        return this.homepageDataService.getHomePageData();
    }

    public async login(): Promise<Auth> {
        return this.loginService.login();
    }
}